import { PayloadAction } from '@reduxjs/toolkit';
import { ModalData } from './types';

export const reducers = {
  openModal(state, action: PayloadAction<ModalData>) {
    state.data = action.payload;
  },
};
